'use strict'

import HttpClient from './HttpClient'
// import store from '../../store'

class Company extends HttpClient {
  getCompanyInfo () {
    var url = '/api/company/info/get'

    return this.sendGet(url, this.headers)
  }
  getCompanyAll () {
    var url = '/api/company/name/all'

    return this.sendGet(url, this.headers)
  }
  createVendorGroup (data) {
    var url = '/api/shipper/create/vendor/group'

    return this.sendPost(url, this.headers, data)
  }
  getVendorGroupAll () {
    var url = '/api/shipper/vendor/groups'

    return this.sendGet(url, this.headers)
  }
  deleteVendorGroup (id) {
    var url = '/api/shipper/delete/vendor/group'
    var data = {
      vendorGroupId: id
    }

    return this.sendDelete(url, this.headers, data)
  }
  updateVendorGroup (data) {
    var url = '/api/shipper/update/vendor/group'

    return this.sendPut(url, this.headers, data)
  }
  getVendorGroup (id) {
    var url = '/api/shipper/vendor/group' + '/' + id

    return this.sendGet(url, this.headers)
  }
  getOneCompanyInfo (id) {
    var url = '/api/company/view/one/details' + '/' + id

    return this.sendGet(url, this.headers)
  }
  updateCompanyInfo (data) {
    var url = '/api/company/user/edit'

    return this.sendPut(url, this.headers, data)
  }
}

export default Company
